$(document).ready(function()
{


    $('html').removeAttr("style");

    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }


    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) 
        { // Esc

            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps 
            $('#protectedDownloadsModal').modal('hide');

            $("html").removeClass("search-is-open");
            $("html").removeClass("nav-is-open");
            $("html").removeClass("location-is-open");

        }
    });

    if ($('.fancybox').length)
    {
        $(".fancybox").fancybox(
        {
            beforeShow : function()
            {
                this.title =  $(this.element).data("caption");
            },
            openEffect: "none",
            closeEffect: "none",

            helpers: 
            { 
                overlay: 
                {
                     css: { 'background': 'rgba(236, 236, 236, 0.8)' }
                } 
            } 
        });
    }
 

});